
import './tableComponent.css';
import React from 'react';

function TableComponent({  maxWidth, isHeaderExist=true, headers, children}) {

    return (
        <table className="table" style={{ maxWidth: `${maxWidth}px` }}>
            {
                isHeaderExist && (
                    <thead>
                        <tr>
                            {
                                headers.map((header, index)=>(
                                   <th key={index}>{header}</th>
                                ))
                            }
                        </tr>
                    </thead>
                )
            }
            <tbody>
              {children}
            </tbody>
        </table>
    )
}

export default TableComponent
